import Tabby from "tabbyjs";

if (document.querySelectorAll(".tabbyjs__content").length > 0) {
    new Tabby("[data-tabs]");
}
